export default __webpack_public_path__ + "static/media/ser-bazylia-pomidor.0b5c6fd8.png";